import React, { useEffect } from 'react';
import {
	Autocomplete,
	Grid,
	Stack,
	TextField,
	Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
	calculateBiasProgress,
	getBiasInfo,
	getSubBiasInfo,
	registerSubBias,
	updateSubBias,
} from '../../actions/biases';
import { useNavigate, useParams } from 'react-router-dom';
import { getCatalogList } from '../../actions/catalogs';
import { handleError, handleSuccess, sortSizes } from '../../helpers/utils';

export const NewSubBiasForm = ({ edit = false }) => {
	// Navigation
	const navigate = useNavigate();

	// URL params
	const { idOrder = null, idBias = null, idSubBias = null } = useParams();

	// Define state to know if it's loading or not
	const [isLoading, setIsLoading] = useState(false);

	// Form
	const [units, setUnits] = useState('');
	const [size, setSize] = useState(null);
	const [sizes, setSizes] = useState([]);

	// Current user
	const { user } = useSelector((state) => state);

	// Handle submit
	const handleSubmit = () => {
		const formData = {
			name: '',
			units: parseInt(units),
			size: sizes.find((item) => item.name === size).id,
			bias: parseInt(idBias),
			created_by: user.id,
		};

		console.log(formData);

		const path = `/dashboard/order/${idOrder}/bias/${idBias}`;

		if (edit) {
			updateSubBias(idSubBias, formData)
				.then(() => {
					handleSuccess('Talla actualizada correctamente.');
					localStorage.setItem('currentPathPilu', path);
					navigate(path);
				})
				.catch((error) => {
					handleError(error, 'No se pudo actualizar la talla.');
				});
		} else {
			registerSubBias(formData)
				.then(async () => {
					await registerEvent({
						title: 'Nueva talla',
						description: `Se registró la talla "${formData.size}" con ${formData.units} unidades.`,
						type: 'INF',
						created_by: user.id,
						bias: newBias.id,
					});
					handleSuccess('Talla agregada correctamente.');
					localStorage.setItem('currentPathPilu', path);
					const bias = (await getBiasInfo(idBias)).data;
					await calculateBiasProgress(bias);
					navigate(path);
				})
				.catch((error) => {
					handleError(error, 'No se pudo agregar la talla.');
				});
		}
		setIsLoading(false);
	};

	const TextFieldComponent = (params, label) => (
		<TextField
			fullWidth
			required
			margin='normal'
			{...params}
			label={label}
		/>
	);

	useEffect(() => {
		getCatalogList('size').then(({ data }) => {
			setSizes(data.results);
		});
	}, []);

	useEffect(() => {
		if (edit) {
			getSubBiasInfo(idSubBias).then(({ data }) => {
				setName(data ? data.name : '');
				setUnits(data ? data.units : '');
				setSize(data ? data.size.name : null);
			});
		}
	}, []);

	return (
		<div style={{ padding: '25px' }}>
			<Stack
				direction='column'
				alignItems='flex-start'
				justifyContent='space-between'
				style={{
					border: '1px solid white',
					padding: '20px 20px 0 0',
					margin: '0 0 10px 0',
					width: '100%',
				}}
			>
				<Typography variant='h4' gutterBottom>
					Talla
				</Typography>
				<Typography variant='p' gutterBottom>
					Complete el formulario para{' '}
					{edit ? 'editar la' : 'crear una nueva'} talla
				</Typography>
			</Stack>
			<hr />
			<Grid container spacing={2} className='mt-2'>
				{/* <Grid item xs={6}>
					<TextField
						required
						fullWidth
						label='Nombre'
						value={name}
						helperText='Nombre corto y descriptivo'
						onChange={({ target }) => setName(target.value)}
					/>
				</Grid> */}

				<Grid item xs={6}>
					<TextField
						required
						fullWidth
						label='Unidades'
						value={units}
						onChange={({ target }) => setUnits(target.value)}
					/>
				</Grid>

				<Grid item xs={6}>
					<Autocomplete
						required
						style={{ marginTop: '-17px' }}
						fullWidth
						value={size}
						onChange={(_, value) => {
							setSize(value);
						}}
						options={sortSizes(sizes, 'name').map(
							(item) => item.name
						)}
						renderInput={(params) =>
							TextFieldComponent(params, 'Tallas')
						}
					/>
				</Grid>

				<Grid item xs={6}>
					<LoadingButton
						fullWidth
						size='large'
						color='error'
						onClick={() => {
							const path = `/dashboard/order/${idOrder}/bias/${idBias}`;
							localStorage.setItem('currentPathPilu', path);
							navigate(path);
						}}
						variant='contained'
						loading={false}
					>
						Cancelar
					</LoadingButton>
				</Grid>

				<Grid item xs={6}>
					<LoadingButton
						fullWidth
						size='large'
						type='submit'
						variant='contained'
						loading={isLoading}
						style={{ backgroundColor: '#143f6c' }}
						onClick={handleSubmit}
					>
						{edit ? 'Actualizar' : 'Crear'}
					</LoadingButton>
				</Grid>
			</Grid>
		</div>
	);
};
